import React from 'react';  // eslint-disable-line

const Share = () => {
    return (
        <svg width="10" height="11" viewBox="0 0 10 11" xmlns="http://www.w3.org/2000/svg"><path d="M6.812 4.003H8.85v6.207H1.38V4.003h2.037m0-2.069L5.115.21l1.697 1.724M5.115.21v6.552" stroke="#CDCDCD" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" /></svg>
    );
};

export default Share;
